import { SignupTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const SignupTrackingSchema: Record<SignupTrackingPoint, string> = {
  [SignupTrackingPoint.SignupPageView]: '89b15e68-9b21-48a8-b526-62b0d6d74aa0',
  [SignupTrackingPoint.SignupHelpButtonClick]:
    'b13bb1e1-c1fe-420d-9e1d-55b896fd896c',
  [SignupTrackingPoint.SignupNextButtonClick]:
    '81c75ec3-1c2b-44da-bcc6-4a5ab29e74c7',
  [SignupTrackingPoint.EnterpriseAccountSubmitFormButtonClick]:
    '610e8a5d-5956-4116-9ce5-559c7256224d',
  [SignupTrackingPoint.PhoneAlreadyRegisteredPageView]:
    '12eac9ea-9cc7-44aa-a49e-3f7e3adeb8b2',
  [SignupTrackingPoint.PhoneAlreadyRegisteredLoginButtonClick]:
    'be008f76-c730-43a5-bde4-ba73ee3fe3b8',
  [SignupTrackingPoint.PhoneAlreadyRegisteredContactUsButtonClick]:
    '96272259-f688-4663-9f8a-a49237b8c4b7',
  [SignupTrackingPoint.PhoneAlreadyRegisteredHelpButtonClick]:
    '5d9bf847-6d95-4bb0-9251-619cda686e5c',
  [SignupTrackingPoint.EmailAlreadyRegisteredPageView]:
    '93d50497-5868-4922-802a-777cf1af844d',
  [SignupTrackingPoint.EmailAlreadyRegisteredLoginButtonClick]:
    '6129d913-c0ab-4f7f-9ee1-7e673d162673',
  [SignupTrackingPoint.EmailAlreadyRegisteredContactUsButtonClick]:
    '71cb5ab3-1460-4881-9c23-8587f3ff7d73',
  [SignupTrackingPoint.EmailAlreadyRegisteredHelpButtonClick]:
    '77975b97-5655-4d4a-8651-436ddb92fa2c',
  [SignupTrackingPoint.SignupSetPasswordPageView]:
    '43dc0a93-97a0-4009-91eb-6b93e18d1f3e',
  [SignupTrackingPoint.SignupSetPasswordSignupButtonClick]:
    '860c6b38-8e25-4cf7-a37c-e6c0bb51cd5b',
  [SignupTrackingPoint.SignupSetPasswordBackButtonClick]:
    '3b4b490e-85b4-4895-bf0e-1c38216cd3d1',
  [SignupTrackingPoint.SignupSuccessPageView]:
    '6155c687-327e-4574-8940-7cd96e87bc5f',
  [SignupTrackingPoint.SignupSuccessPageNextButtonClick]:
    '5902cb94-4a9d-4a89-897e-4571249a969a',
  [SignupTrackingPoint.SignupSuccessPageBackButtonClick]:
    'b5defdb3-729e-47ba-beb0-cb1d3c00a881',
  [SignupTrackingPoint.SignupSuccessAction]:
    '0da76dec-2e7d-4cdb-a6d8-7cbe1e3de00b',
  [SignupTrackingPoint.QuickLoginToggleImpression]:
    'bf6b052e-b2a7-40ee-9df9-264bf6d801ea',
  [SignupTrackingPoint.QuickLoginToggleClick]:
    'a8c2255a-aa89-4d6a-8f98-363969792b9a',
  [SignupTrackingPoint.QuickLoginTooltipImpression]:
    '66a520ec-0cf5-4435-829c-0a116cfefc72',
  [SignupTrackingPoint.QuickLoginActionSuccess]:
    '867af343-9361-4fa1-9de2-73ecea3e032b',
  [SignupTrackingPoint.LoginSuccessAction]:
    '04e79e19-6dc2-420b-8d9e-18817bf96f1e',
};

export const getSignupSetPasswordPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupSetPasswordPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};

export const getSignupSuccessPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupSuccessPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};

export const getSignupPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};

export const getSignupAccountPhoneAlreadyRegisteredPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupPhoneAlreadyRegisteredPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};

export const getSignupAccountEmailAlreadyRegisteredPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupEmailAlreadyRegisteredPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};
